import React from 'react';
import logoImage from '@/assets/images/contemplate black_edited.png';

const Footer = () => {
  return (
    <footer className="bg-[#efede6] py-16 border-t border-[#202020]/10">
      <div className="max-w-5xl mx-auto px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img 
              src={logoImage} 
              alt="Contemplate"
              className="h-7"
            />
          </div>

          {/* Links */}
          <div className="flex items-center gap-10">
            <a href="#privacy" className="text-[#202020]/50 hover:text-[#202020] transition-colors text-sm">
              Privacy
            </a>
            <a href="#terms" className="text-[#202020]/50 hover:text-[#202020] transition-colors text-sm">
              Terms
            </a>
            <a href="#contact" className="text-[#202020]/50 hover:text-[#202020] transition-colors text-sm">
              Contact
            </a>
          </div>

          {/* Copyright */}
          <p className="text-[#202020]/40 text-sm">
            © {new Date().getFullYear()} Contemplate. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
